export type { CollapsibleProps } from './Collapsible'
export { Collapsible } from './Collapsible'
export type { CollapsibleProviderProps } from './useCollapsible.constate'
export {
  CollapsibleProvider,
  useCollapsibleContext,
} from './useCollapsible.constate'
